import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgRepost = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.1247 5.5C19.6081 5.5 20 5.85698 20 6.29734V12.5H21.5432C21.7674 12.5 21.954 12.6749 21.9926 12.9056L22 12.9945C22 13.0905 21.9742 13.1845 21.9257 13.2649L18.9092 18.2648C18.774 18.4216 18.6376 18.5 18.5 18.5C18.3624 18.5 18.2261 18.4216 18.0909 18.2648L15.0744 13.2649C14.9364 13.0362 14.9959 12.7298 15.2071 12.5805C15.2814 12.528 15.3682 12.5 15.4569 12.5H17L16.999 8.499L9.71232 8.5C9.48959 8.5 9.28164 8.35637 9.15834 8.11736L8.03708 5.94388C8.0129 5.89701 8 5.84199 8 5.78571C8 5.62792 8.09927 5.5 8.22174 5.5H19.1247ZM4.87533 18.5C4.3919 18.5 4 18.143 4 17.7027L3.999 11.5H2.45685C2.23257 11.5 2.04604 11.3251 2.00736 11.0944L2 11.0055C2 10.9095 2.02583 10.8155 2.07434 10.7351L5.09081 5.73518C5.226 5.57839 5.36239 5.5 5.49997 5.5C5.63756 5.5 5.77394 5.57839 5.90914 5.73518L8.92561 10.7351C9.06357 10.9638 9.00415 11.2702 8.79289 11.4195C8.71861 11.472 8.63181 11.5 8.5431 11.5H6.999L7 15.5H14.2877C14.5104 15.5 14.7184 15.6436 14.8417 15.8826L15.9629 18.0561C15.9871 18.103 16 18.158 16 18.2143C16 18.3721 15.9007 18.5 15.7783 18.5H4.87533Z", fill: props.fill }));
});
export default SvgRepost;
